module.exports = __webpack_public_path__ + "img/banner10.237bb8e2.jpg";